import { GridItem } from '@chakra-ui/react';

export const GridItemCentered = (props) => (
    <GridItem bg="grayDark2" display="flex" alignItems="center" justifyContent="center" {...props} />
);
